import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import MainLayout from "./layout";
import { ThreeDots } from "react-loader-spinner";

const Home = lazy(() => import("./home"));
const AboutMMI = lazy(() => import("./pages/About/AboutMMI"));
const Administration = lazy(() => import("./pages/Administration/Administration"));
const Priest = lazy(() => import("./pages/Administration/Priest"));
const ViceProvince = lazy(() => import("./pages/Administration/ViceProvince"));
const Delegations = lazy(() => import("./pages/Administration/Delegations"));
const CountryHead = lazy(() => import("./pages/Administration/CountryHead"));
const Spiritual = lazy(() => import("./pages/Spiritual/Spiritual"));
const OurPresence = lazy(() => import("./pages/OurPresence/OurPresence"));
const Vocations = lazy(() => import("./pages/Vocations/Vocations"));
const Formation = lazy(() => import("./pages/Formation/Formation"));
const Privacy = lazy(() => import("./pages/PrivacyPolicy/Privacy"));
const PhotoGallery = lazy(() => import("./pages/Gallery/PhotoGallery"));
const Contact = lazy(() => import("./pages/ContactUs/contact"));
const CalendarComponent = lazy(() => import("./pages/Calendar/Calendar"));
const FounderMessage = lazy(() => import("./pages/Message/FounderMessage"));
const PatronMessage = lazy(() => import("./pages/Message/PatronMessage"));
const VideoComponent = lazy(() => import("./pages/Gallery/VideoGallery"));
const Blog = lazy(() => import("./pages/Blog/Blog"));
const BlogPost = lazy(() => import("./pages/Blog/BlogPost"));

// Dynamic / previously unregistered pages
const NewsEvents = lazy(() => import("./pages/NewsEvents"));
const NewsLetter = lazy(() => import("./pages/NewsLetter"));

const LoadingSpinner = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "50vh",
    }}
  >
    <ThreeDots
      visible={true}
      height="50"
      width="50"
      color="#172440"
      radius="9"
      ariaLabel="three-dots-loading"
    />
  </div>
);

function App() {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/*" element={<MainLayout />}>
          <Route path="about-mmi" element={<AboutMMI />} />
          <Route path="history" element={<AboutMMI />} />
          <Route path="general-admin" element={<Administration />} />
          <Route path="province" element={<Priest />} />
          <Route path="vice-province" element={<ViceProvince />} />
          <Route path="delegations" element={<Delegations />} />
          <Route path="country-heads" element={<CountryHead />} />
          <Route path="sprituality" element={<Spiritual />} />
          <Route path="our-presence" element={<OurPresence />} />
          <Route path="african-province" element={<OurPresence />} />
          <Route path="rome" element={<OurPresence />} />
          <Route path="francis-province" element={<OurPresence />} />
          <Route path="malawi" element={<OurPresence />} />
          <Route path="papuva-new-guinea" element={<OurPresence />} />
          <Route path="tanzanian" element={<OurPresence />} />
          <Route path="vocations" element={<Vocations />} />
          <Route path="formation" element={<Formation />} />
          <Route path="gallery" element={<PhotoGallery />} />
          <Route path="video-gallery" element={<VideoComponent />} />
          <Route path="privacy-policy" element={<Privacy />} />
          <Route path="contact-us" element={<Contact />} />
          <Route path="calendar" element={<CalendarComponent />} />
          <Route path="founder-message" element={<FounderMessage />} />
          <Route path="bishop-message" element={<PatronMessage />} />
          <Route path="blog" element={<Blog />} />
          <Route path="blog/:slug" element={<BlogPost />} />
          
          {/* Missing dynamic paths */}
          <Route path="news-events" element={<NewsEvents />} />
          <Route path="newsletter" element={<NewsLetter />} />
          <Route path="provincial-programs" element={<CalendarComponent />} />
          
          {/* Fallback 404 page */}
          <Route
            path="*"
            element={
              <div className="container text-center py-5">
                <h3>404 - Page Not Found</h3>
                <a href="/" className="btn btn-primary mt-3">Go Home</a>
              </div>
            }
          />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
